import { useTranslation } from 'react-i18next'

import { HierarchicalSelector } from '@reveni-io/reveni-ui'

const HierarchicalInput = ({ value = [], onChange, comboItems, disabled, hasError }) => {
  const { t } = useTranslation()

  const showError = hasError && (!Array.isArray(value) || value.length === 0)

  const getChildrenCountLabel = count => {
    return count === 1 ? t('1 submotivo') : t('{{length}} submotivos', { length: count })
  }

  return (
    <HierarchicalSelector
      label={t('Motivos de devolución')}
      options={comboItems}
      value={value}
      onChange={onChange}
      searchPlaceholder={t('Buscar en cualquier nivel (motivo, submotivo)')}
      getChildrenCountLabel={getChildrenCountLabel}
      disabled={disabled}
      error={showError}
      helperText={showError ? t('Este campo es obligatorio') : ' '}
      fullWidth
    />
  )
}

export default HierarchicalInput
